import { useEffect } from 'react';
import { useTracking } from '@podiumhq/tracking';

import useFullStoryEvent from 'components/ThirdPartyScripts/hooks/useFullStoryEvent';
import { CHAT_WITH_SALES_CHILI_PIPER_URL } from 'routes/constants';

import { handleOnToggleFeatureList } from '../../utils';

export const useSelectPlanTrackEvents = ({
  ctaEvent = 'planClicked',
  fullStoryOnLoadEvent = 'Checkout Select Plan Pricing Page Visited',
  shouldOpenSalesAssist = false,
  trackEventPath = 'selectPlanCheckout.selectPlan',
} = {}) => {
  const fullStoryEvent = useFullStoryEvent();
  const { trackEvent } = useTracking();

  const bundleCardCtaTrackEvent = (bundleName, term) => {
    trackEvent(`${trackEventPath}.${ctaEvent}`, { plan: bundleName, term });

    if (shouldOpenSalesAssist) {
      window.open(CHAT_WITH_SALES_CHILI_PIPER_URL, '_blank').focus();
    }
  };

  const onToggleFeatureList = (bundleName) =>
    handleOnToggleFeatureList(bundleName, trackEvent, trackEventPath);

  const trackPlanTermToggle = (isYearlySelected) =>
    trackEvent(
      `${trackEventPath}.${
        isYearlySelected
          ? 'planDurationYearlySelected'
          : 'planDurationMonthlySelected'
      }`
    );

  useEffect(() => {
    trackEvent(`${trackEventPath}.visited`);
    fullStoryOnLoadEvent && fullStoryEvent(fullStoryOnLoadEvent);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    bundleCardCtaTrackEvent,
    onToggleFeatureList,
    trackEvent,
    trackPlanTermToggle,
  };
};
